export const UPDATE_TRAVELLER_DETAILS = 'UPDATE_TRAVELLER_DETAILS';
export const TOGGLE_TRAVELLER_PROFILE_TYPE = 'TOGGLE_TRAVELLER_PROFILE_TYPE';
export const RESET_TRAVELLER_DETAILS = 'RESET_TRAVELLER_DETAILS';
export interface IUpdateProfileType {
  type: string;
  actionData: object;
}

export interface IUpdateTravellerDetails {
  type: string;
  actionData: TravellerDetailsTypes['formData'];
}

export interface ACTION_UPDATE_TRAVELLER_DETAILS_TYPE {
  type: typeof UPDATE_TRAVELLER_DETAILS;
  actionData: TravellerDetailsTypes['formData'];
}

export interface ACTION_RESET_TRAVELLER_DETAILS_TYPE {
  type: typeof RESET_TRAVELLER_DETAILS;
}

export interface TravellerDetailsTypes {
  formData: {
    nameDetails?: Array<NameDetails>;
    email?: string;
    phoneNumber?: string;
    businessProfile?: boolean;
    gstNumber?: string;
    travellersPan?: string;
    countryCode?: string;
    companyName?: string;
    businessEmail?: string;
    companyAddress?: string;
    companyPhone?: string;
    companyEmail?: string;
    specialReq?: string;
    selectedCheckinTime?: string;
  };
}

interface NameDetails {
  nameTitle: string;
  firstName: string;
  lastName: string;
  middleName: string;
}

export type TravellerDetailsActionTypes =
  | ACTION_UPDATE_TRAVELLER_DETAILS_TYPE
  | ACTION_RESET_TRAVELLER_DETAILS_TYPE;
